import Quill from 'quill';
import Emoji from 'quill-emoji';
import 'quill-emoji/dist/quill-emoji.css';
import React from 'react';
import List from '../../assets/svg/List';

Quill.register('modules/emoji', Emoji);
Quill.import('attributors/style/font');

const CustomUndo = () => (
  <svg viewBox="0 0 18 18">
    <polygon className="ql-fill ql-stroke" points="6 10 4 12 2 10 6 10" />
    <path
      className="ql-stroke"
      d="M8.09,13.91A4.6,4.6,0,0,0,9,14,5,5,0,1,0,4,9"
    />
  </svg>
);

const CustomRedo = () => (
  <svg viewBox="0 0 18 18">
    <polygon className="ql-fill ql-stroke" points="12 10 14 12 16 10 12 10" />
    <path
      className="ql-stroke"
      d="M9.91,13.91A4.6,4.6,0,0,1,9,14a5,5,0,1,1,5-5"
    />
  </svg>
);

function Button(props) {
  return <button {...props} type="button" />;
}
function Select(props) {
  return <select {...props} />;
}

function undoChange() {
  this.quill.history.undo();
}
function redoChange() {
  this.quill.history.redo();
}

export const modules = {
  toolbar: {
    container: '#toolbar',
    handlers: {
      undo: undoChange,
      redo: redoChange,
    },
    list: 'bullet',
  },
  history: {
    delay: 500,
    maxStack: 100,
    userOnly: true,
  },
  'emoji-toolbar': true,
  'emoji-shortname': true,
};

export const formats = [
  'header',
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'align',
  'strike',
  'script',
  'blockquote',
  'background',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
  'color',
  'code-block',
  'emoji',
];

export const QuillToolbar = () => (
  <div id="toolbar">
    <span className="ql-formats">
      <Button className="ql-bold" />
      <Button className="ql-italic" />
      <Button className="ql-list" value="bullet">
        <List />
      </Button>
      <Button className="ql-strike" />
      <Button className="ql-emoji" />
    </span>
    <span className="ql-formats">
      <Select className="ql-color" />
    </span>
    <span className="ql-formats">
      <Button className="ql-undo">
        <CustomUndo />
      </Button>
      <Button className="ql-redo">
        <CustomRedo />
      </Button>
    </span>
  </div>
);

export default QuillToolbar;
